var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoCardless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8771 8.50063C28.3391 8.50063 30.2877 9.06874 30.2877 9.06874L36.0417 20.819L35.9908 20.8698L28.5833 16.453C24.292 13.8968 21.1734 12.5534 18.6429 12.6557C15.9618 12.7066 14.3541 14.8629 14.3541 17.9922C14.4508 25.9986 22.0566 35.8486 29.6122 35.8486C32.6964 35.8486 34.3015 34.8574 35.2413 33.6559L24.0535 21.3802V21.3293H39.419C39.6286 22.4285 39.7429 23.5447 39.7598 24.664C39.7598 33.6446 32.8866 40.8788 24.4057 40.8788C15.9247 40.8788 9.00002 33.6446 9.00002 24.664C8.98558 15.7342 15.8595 8.50063 24.8771 8.50063Z",
    fill: "url(#paint0_linear_351_120)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_351_120",
    x1: 8.9891,
    y1: 8.5,
    x2: 40.3709,
    y2: 40.2301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoCardless);
export default __webpack_public_path__ + "static/media/GoCardless.6213452cb0421f717a82cdc8825dad90.svg";
export { ForwardRef as ReactComponent };